import noData from "../../assets/no-data.svg";

const NoDataComponent = () => {
  return (
    <div className="h-full w-full px-5 pb-10">
      <img
        src={noData}
        alt="no data"
        className="h-full w-full object-contain"
      />
    </div>
  );
};

export default NoDataComponent;
